import { cardNetworkValidator } from "cc-tools/card-network-validator";

import { CreditCardNetwork } from "chameleon/lib/components/display-cards/display-cards";

import {
  CardNetwork,
  GetMerchantSettingsResponse_MerchantSettings,
  PlainMessage,
} from "frontend-client";

export const cardNetwork =
  ({
    allowedCardNetworks = [],
  }: {
    allowedCardNetworks?: CreditCardNetwork[];
  }) =>
  (value: string): boolean => {
    const { isAllowedCardNetwork } = cardNetworkValidator(
      value,
      allowedCardNetworks
    );
    return isAllowedCardNetwork;
  };

export const getIsCobrandedCardNetworksEnabled = (
  merchantSettings?:
    | PlainMessage<GetMerchantSettingsResponse_MerchantSettings>
    | undefined
) => {
  // modify this if any other future cobranded card logic is needed
  return merchantSettings?.paymentMethods?.cardPaymentMethod?.supportedCards?.some(
    (card) => card.network === CardNetwork["CARTES_BANCAIRES"]
  )
    ? true
    : false;
};
